import * as React from 'react';

// tslint:disable-next-line: match-default-export-name
import { DropdownMenu, IDropdownMenuLink } from '../../components/DropdownMenu/';
import { TDropdownType } from '../../components/DropdownMenu/interfaces';
import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';

interface IDropdownMenuContainerState {
  hasShadow?: boolean;
  links: IDropdownMenuLink[];
  show: boolean;
}

export interface IDropdownMenuContainerProps {
  name: TDropdownType;
  links: IDropdownMenuLink[];
  isOpen?: boolean;
  otherLinks?: IOtherLinksSchema | null;
  agenciesUrl?: string;
  onClose?(): void;
  onMouseLeave?(key: string): void;
}

export class DropdownMenuContainer extends React.Component<IDropdownMenuContainerProps, IDropdownMenuContainerState> {
  public state = {
    hasShadow: false,
    links: this.props.links,
    show: true,
  };

  public componentDidMount() {
    const { name } = this.props;
    this.setState({
      hasShadow: window.___header_serpPageType !== name,
    });
  }

  public render() {
    const linksOther = this.props.otherLinks || ({} as IOtherLinksSchema);

    return (
      <DropdownMenu
        otherLinks={linksOther}
        links={this.state.links}
        name={this.props.name}
        isOpen={this.props.isOpen}
        hasShadow={this.state.hasShadow}
        agenciesUrl={this.props.agenciesUrl}
        onClose={this.props.onClose}
        onMouseLeave={this.props.onMouseLeave}
      />
    );
  }
}
